module.exports = __webpack_public_path__ + "img/full4-min.cb6d3099.png";